import ARecipeWorkshop from "./A++ Recipe Workshop";
import COMMUTE from "./COMMUTE";
import DESIGN from "./DESIGN";
import DISPLAY from "./DISPLAY";
import EATTransformativeSeeds from "./EAT: Transformative Seeds";
import HEALRepair from "./HEAL: Repair+";
import MAKEMental from "./MAKE: Me(n)tal";
import PLANT from "./PLANT";
import READBOOK from "./READ: BOOK";
import AShoppingExperience from "./A Shopping Experience";
import SLEEPDIVINGIN from "./SLEEP: DIVING IN";
import SLEEPLESS from "./SLEEP: LESS";
import SpecialMenuwithTipo from "./Special Menu with Tipo";
import HowDoWeShop from "./How Do We Shop";
import TheEverydayShop from "./The Everyday Shop";

const AllLongText = {
  ARecipeWorkshop,
  COMMUTE,
  DESIGN,
  DISPLAY,
  EATTransformativeSeeds,
  HEALRepair,
  MAKEMental,
  PLANT,
  READBOOK,
  AShoppingExperience,
  SLEEPDIVINGIN,
  SLEEPLESS,
  SpecialMenuwithTipo,
  HowDoWeShop,
  TheEverydayShop,
};

export default AllLongText;
